/* eslint-disable jira/filename-case, jira/naming/disallow-filenames */
import { isCMDBEnabledInEnvironment } from '@jira/servicedesk__insight-common-utils-cmdb-fedramp/src/isCMDBEnabledInEnvironment.tsx';
import { useTenantContext } from '@atlassian/jira-tenant-context-controller/src/components/tenant-context/index.tsx';

export function useShowAssets(): boolean {
	const tenantContext = useTenantContext();
	const { appPermissions } = tenantContext;

	const isJSMUser = appPermissions.hasServiceDeskAccess;

	if (isCMDBEnabledInEnvironment() && isJSMUser) {
		return true;
	}

	return false;
}
